import Sidemenu from '../components/base/sidemenu';
import { useState } from "react";
import Log from '../components/log/log';
import Log_alim from '../components/log/log_alim';

export default function DashboardPage() {
    const [tab, setTab] = useState("logpage");
    return (
        <div className='flex'>
            <Sidemenu />
            <div className="tabs_wrp user_tabs">
                <button onClick={() => setTab("logpage")} className={tab === "logpage" ? "active" : ""}>로그 관리</button>
                <button onClick={() => setTab("log_alim")} className={tab === "log_alim" ? "active" : ""}>알림 관리</button>
            </div>

            {tab === "logpage" && (<Log />)}
            {tab === "log_alim" && (<Log_alim />)}
            
        </div>
    );
}
